import React from "react";
import Link from "gatsby-link";

class ProductBadges extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const data = this.props.data;

    return (
      <div className="Badges">
        <h2>Yoga Flow is</h2>
        <div className="product-badges">
          <div className="item">
            <div className="shape">
              <div className="vertplacer">
                <p>DAIRY<br/>FREE</p>
              </div>
            </div>
          </div>
          <div className="item">
            <div className="shape">
              <div className="vertplacer">
                <p>GLUTEN<br/>FREE</p>
              </div>
            </div>
          </div>
          <div className="item">
            <div className="shape">
              <div className="vertplacer">
                <p>VEGAN<br/>FRIENDLY</p>
              </div>
            </div>
          </div>
          <div className="item">
            <div className="shape">
              <div className="vertplacer">
                <p>1G <br/>SUGAR</p>
              </div>
            </div>
          </div>
          <div className="item">
            <div className="shape">
              <div className="vertplacer">
                <p>MADE IN<br/><span>THE USA</span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProductBadges;


// WEBPACK FOOTER //
// ./src/buy/badges.js